import { useDispatch } from "app/store";
import useAuth from "features/auth/useAuth";
import React, { useEffect } from "react";
import RepairersFailureList from "./repairer/RepairersFailureList";
import FailureTabs from "./tabs/FailureTabs";
import Claims from "features/auth/claims";

const FailuresListHub: React.FC = () => {
  const dispatch = useDispatch();
  const { hasClaim } = useAuth();
  const view = localStorage.getItem("fortana-view");

  useEffect(() => {
    return () => {
      dispatch.failureList.reset();
    };
  }, [dispatch.failureList]);

  return (hasClaim([Claims.View.Tablet]) && !hasClaim([Claims.View.Desktop])) ||
    (view === "tablet" &&
      hasClaim([Claims.View.Desktop]) &&
      hasClaim([Claims.View.Tablet])) ? (
    <RepairersFailureList />
  ) : (
    <FailureTabs />
  );
};

export default FailuresListHub;
